export default function FormDetailsPage () {
    return (
        <div>
            
        </div>
    )
}